import React, { useMemo } from 'react';
import { Column } from 'react-table';
import { TableContent } from '../../../../manager/components/TableContent';

type Props = {
  categories: string[];
  turnoverRates: number[];
  dataFormatter: (value: number) => string;
};

type TableItem = {
  id: string;
  [key: string]: any;
};

export const EmployeeOvertimeTable: React.FC<Props> = ({
  categories,
  turnoverRates,
  dataFormatter,
}) => {
  const columns: Column[] = useMemo(() => {
    return categories.map((category, index) => ({
      Header: category,
      accessor: `employee${index}`,
    }));
  }, [categories]);

  const data = useMemo(() => {
    const rowData: TableItem = { id: 'turnoverRates' };

    turnoverRates.forEach((rate, index) => {
      rowData[`employee${index}`] = dataFormatter(rate);
    });
    return [rowData];
  }, [turnoverRates, dataFormatter]);

  return <TableContent columns={columns} data={data} />;
};
